import type {
	QuestionDefinition,
	QuestionOption,
} from '#modules/CustomQuestionnaire/types'

import i18n from 'i18next'

export enum ExpenseContributionAnswerType {
	Equal = 'equal',
	DifferentAmounts = 'differentAmounts',
	ApplicantPaysAll = 'applicantPaysAll',
	PartnerPaysAll = 'partnerPaysAll',
}

export const fixedExpensesSplitQuestionId = 'fixedExpensesSplit'
export const differentAmountsSplitSubquestionId = 'differentAmountsSplit'

export const getFixedExpensesSplitQuestion = (): QuestionDefinition => {
	return {
		id: fixedExpensesSplitQuestionId,
		formFieldKey: `${fixedExpensesSplitQuestionId}.answer`,
		questionType: 'singleSelect',
		label: i18n.t(
			'householdSingleCohabitantQuestionnaire-fixedEpensesSplit-questionLabel',
		),
		labelTooltip: i18n.t(
			'householdSingleCohabitantQuestionnaire-fixedEpensesSplit-questionLabelTooltip',
		),
		options: getFixedExpensesSplitOptions(),
		validations: {
			required: true,
		},
	}
}

export const getFixedExpensesSplitOptions = (): QuestionOption[] => {
	return [
		{
			value: ExpenseContributionAnswerType.Equal,
			label: i18n.t(
				'householdSingleCohabitantQuestionnaire-fixedExpensesSplit-optionLabel-equal',
			),
		},
		{
			value: ExpenseContributionAnswerType.DifferentAmounts,
			label: i18n.t(
				'householdSingleCohabitantQuestionnaire-fixedExpensesSplit-optionLabel-differentAmounts',
			),
			subquestions: [getFixedExpensesSplitDifferentAmountsSubquestion()],
		},
		{
			value: ExpenseContributionAnswerType.ApplicantPaysAll,
			label: i18n.t(
				'householdSingleCohabitantQuestionnaire-fixedExpensesSplit-optionLabel-applicantPersonPaysAll',
			),
		},
		{
			value: ExpenseContributionAnswerType.PartnerPaysAll,
			label: i18n.t(
				'householdSingleCohabitantQuestionnaire-fixedExpensesSplit-optionLabel-partnerPaysAll',
			),
		},
	]
}

export const getFixedExpensesSplitDifferentAmountsSubquestion =
	(): QuestionDefinition => {
		return {
			id: differentAmountsSplitSubquestionId,
			formFieldKey: `${fixedExpensesSplitQuestionId}.["subquestions"].["${differentAmountsSplitSubquestionId}"].answer`,
			questionType: 'slider',
			label: i18n.t(
				'householdSingleCohabitantQuestionnaire-differentAmountsSplit-questionLabel',
			),
			sliderConfig: {
				min: 0,
				max: 100,
				step: 1,
				marks: [
					{
						value: 0,
						label: i18n.t(
							'householdSingleCohabitantQuestionnaire-differentAmountsSplit-slider-minMark-label',
						),
					},
					{
						value: 100,
						label: i18n.t(
							'householdSingleCohabitantQuestionnaire-differentAmountsSplit-slider-maxMark-label',
						),
					},
				],
			},
			validations: {
				required: true,
				min: {
					value: 0,
					message: i18n.t('requires a valid percentage between 0 and 100'),
				},
				max: {
					value: 100,
					message: i18n.t('requires a valid percentage between 0 and 100'),
				},
			},
		}
	}
